var _rect, _rect2, _rect3, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScrollToTopArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 21 24",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 14.4995,
    width: 1,
    height: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 17.4995,
    width: 1,
    height: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 20.4995,
    width: 1,
    height: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5297 1.49952L10.1598 1.85234L4.5 7.15847L5.23985 7.85893L10.0075 3.40373L10.0075 12.1948L11.052 12.1948L11.052 3.40373L15.7601 7.85893L16.5 7.15847L10.8997 1.85234L10.5297 1.49952Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollToTopArrow);
export default __webpack_public_path__ + "static/media/scroll-to-top-arrow.8b703edb74cb41193e401ce283272d0b.svg";
export { ForwardRef as ReactComponent };